var s = "_small_1fpc2_1 _sharedTypography_qj5pz_1",
    l = {
  small: s
};
export { l as default, s as small };